export enum EnvironmentKind {
    DEV = 0,
    BUILD = 1,
    HOMOLOG = 2,
    PROD = 3
}
